import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  CertificationHistoryPreviewDto,
  CertificationInputDto,
  CertificationPreviewDto,
  CertificationSearchResultDto,
} from "../interfaces/Certification";
import { RegisterType } from "../common/interfaces/enums/RegisterType";
import { stringifyBgToIso } from "../common/utils/dateTime";

const apiEndpoint = "/certification";

const getCertificationsAsync = async (query: string): Promise<AxiosResponse<Array<CertificationSearchResultDto>>> => {
  return await http.get<Array<CertificationSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getCertificationsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getCertificationAsync = async (id: number): Promise<AxiosResponse<CertificationPreviewDto>> => {
  return await http.get<CertificationPreviewDto>(`${apiEndpoint}/${id}`);
};

const addCertificationAsync = async (model: CertificationInputDto): Promise<AxiosResponse<CertificationInputDto>> => {
  return await http.post<CertificationInputDto>(apiEndpoint, model);
};

const updateCertificationAsync = async (
  model: CertificationInputDto
): Promise<AxiosResponse<CertificationInputDto>> => {
  return await http.put<CertificationInputDto>(`${apiEndpoint}/${model.certificationId}`, model);
};

const getCertificationHistoryAsync = async (id: number): Promise<AxiosResponse<CertificationHistoryPreviewDto>> => {
  return await http.get<CertificationHistoryPreviewDto>(`${apiEndpoint}/history/${id}`);
};

const getCertificationIdByYearAsync = async (
  registerType: RegisterType,
  userId: number,
  registrationNumber?: number,
  issueDate?: Date
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(
    `${apiEndpoint}/idByYear?userId=${userId}&registerType=${registerType}&registrationNumber=${registrationNumber}&issueDate=${stringifyBgToIso(
      issueDate
    )}`
  );
};

export default {
  getCertificationsAsync,
  getCertificationsCountAsync,
  getCertificationAsync,
  addCertificationAsync,
  updateCertificationAsync,
  getCertificationHistoryAsync,
  getCertificationIdByYearAsync,
};
